import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';

import {planPropTypes} from '../../../../utils/propTypes';

import Option from './Option';

function DetailsOptions({plan, isOpen}) {
  if (!isOpen || isEmpty(plan.options)) {
    return null;
  }

  return (<>
    <hr className="my-4"/>

    <div className="row">
      <div className="col-12 d-flex flex-column align-items-center">
        <strong className="information-primary uppercase font-size-xl">
          <Translate value="subscriptions.plans.option"/>
        </strong>
      </div>
    </div>
    {plan.options.map(option => (
      <Option
        plan={plan}
        option={option}
        key={option.id}
      />
    ))}
  </>);
}

DetailsOptions.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  plan: planPropTypes().isRequired
};

export default DetailsOptions;
